export default __webpack_public_path__ + "static/media/HDTX_Audit Report 2025.3ef35b8c.pdf";